// Shim the core JavaScript Date and Date.prototype objects for Moment.js support

Date.prototype.addHours = function(h) {
	this.setTime(this.getTime() + (h*60*60*1000));
	return this;
};

Date.prototype.dateFormat = function(format) {
	return moment(this).format(format);
};

Date.parseDate = function(input, format) {
	return moment(input, format).toDate();
};
